/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Soft_Warm_Mule_PlanInputs */

const en_soft_warm_mule_plan = /** @type {(inputs: Soft_Warm_Mule_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All labels`)
};

const de_soft_warm_mule_plan = /** @type {(inputs: Soft_Warm_Mule_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Labels`)
};

/**
* | output |
* | --- |
* | "All labels" |
*
* @param {Soft_Warm_Mule_PlanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const soft_warm_mule_plan = /** @type {((inputs?: Soft_Warm_Mule_PlanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_Warm_Mule_PlanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_soft_warm_mule_plan(inputs)
	return de_soft_warm_mule_plan(inputs)
});